import { connect } from "react-redux";

import Navigation from "./Navigation";
import { State } from "../../../store/state";

const mapStateToProps = (state: State) => ({
  authenticatedWithKeycloak: state.authentication.authenticatedWithKeycloak,
});

const NavigationContainer = connect(mapStateToProps)(Navigation);

export default NavigationContainer;
